import { jsx as a } from "react/jsx-runtime";
import { MercadoPagoCardDetails as o } from "./mercado-pago/card/details.mjs";
import c from "./payment-inputs/index.mjs";
import { StripeCardDetails as i } from "./stripe/stripe-card/components/stripe-card-details.mjs";
import { PaymentMethodEnum as r } from "@systemeio/ui";
import { StripeBancontactDetails as s } from "./stripe/stripe-bancontact/details.mjs";
import { StripeKlarnaDetails as m } from "./stripe/stripe-klarna/details.mjs";
import { StripeIdealDetails as p } from "./stripe/stripe-ideal/details.mjs";
const x = (e, t) => {
  switch (e) {
    case r.stripe_card:
      return /* @__PURE__ */ a(i, { ...t });
    case r.stripe_ideal:
      return /* @__PURE__ */ a(p, {});
    case r.stripe_klarna:
      return /* @__PURE__ */ a(m, {});
    case r.stripe_bancontact:
      return /* @__PURE__ */ a(s, {});
    case r.mercadopago_ar_card:
    case r.mercadopago_br_card:
    case r.mercadopago_cl_card:
    case r.mercadopago_co_card:
    case r.mercadopago_mx_card:
      return /* @__PURE__ */ a(o, {});
    case r.xendit_id_card:
    case r.xendit_ph_card:
      return /* @__PURE__ */ a(c, {});
  }
};
export {
  x as getPaymentProcessorDetails
};
